import * as React from 'react';
import { cloneElement } from 'react';
import { RefreshButton } from 'react-admin';
import { Box, makeStyles, Theme } from '@material-ui/core';
import { actionsStyles } from '../../../theme/customTheme';
import DynamicColumns from './dynamicColumns';
import QrScanButton from './QrScanButton';

const styles = (theme: Theme) => ({
    ...actionsStyles(theme),
    cardActions: {},
    actionsBar: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        '@media (max-width:600px)': {
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            gap: '4px',
        },
    },
    actionButton: {
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: '8px',
        padding: '8px 16px',
        marginRight: '12px',
        fontSize: '0.875rem',
        fontWeight: 600,
        minHeight: '36px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
        },
        '&:active': {
            transform: 'translateY(0)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
    },
    refreshButton: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: '8px',
        padding: '8px 16px',
        fontSize: '0.875rem',
        fontWeight: 600,
        minHeight: '36px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
        },
        '&:active': {
            transform: 'translateY(0)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
    },
    menuListRoot: {
        padding: 0,
    },
    menuListItemRoot: {
        marginRight: 5,
    },
    menuRoot: {
        padding: '2px 10px 2px 5px',
    },
    menuIcon: {
        fontSize: 20,
    },
    menuTextRoot: {
        padding: 0,
    },
    menuText: {
        fontSize: '0.875rem',
        fontWeight: 'bold',
    },
    rootCheckbox: {
        padding: 0,
        //@ts-ignore
        marginRight: theme.spacing.unit,
    },
    multiSelectLabel: {
        color: theme.palette.primary.main,
        fontSize: 13,
        fontWeight: 500,
    },
    multiSelectLabelCheckbox: {
        padding: 6,
        color: theme.palette.primary.main,
    },
    formControlLabelRoot: {
        marginLeft: -5,
        marginRight: 5,
    },
    dialogTitle: {
        padding: '17px 20px 0 20px',
        paddingBottom: 15,
    },
    dialogTitleText: {
        fontWeight: 'bold',
        fontSize: 17,
    },
    container: {
        display: 'grid',
        gridTemplateColumns: '30px auto',
        alignItems: 'center',
        columnGap: '7px',
    },
    dialogActions: {
        marginRight: 20,
        marginBottom: 20,
    },
    button: {
        paddingLeft: 30,
        paddingRight: 30,
        marginLeft: 10,
    },
    circularProgress: {
        marginTop: '20px',
        marginBottom: '20px',
        overflowY: 'hidden',
    },
    dialogContent: {
        paddingBottom: 0,
    },
    dialogText: {
        color: 'black',
        fontSize: 13,
    },
    buttonMenu: {
        paddingLeft: 10,
    },
});
//@ts-ignore
const useStyles = makeStyles(styles);
const ListActions = (props: any) => {
    const { filters, toggleColumn, enabledColumns, viewMode, extraActions } = props;

    const classes = useStyles();

    return (
        <Box className={classes.actionsBar}>
            <QrScanButton />

            {filters && cloneElement(filters, { context: 'button' })}

            {viewMode !== 'cards' && (
                <DynamicColumns toggleColumn={toggleColumn} enabledColumns={enabledColumns} classesProps={classes} />
            )}

            <RefreshButton />

            {extraActions}
        </Box>
    );
};

export default ListActions;
